import React from 'react';
import { IProps } from './types';
import MemberProfileForm from 'components/MemberProfileForm';
import { MemberProfileTitle } from 'constants/enums/memberProfileTitle.enum';

const MemberProfile: React.FC<IProps> = (props) => {
  return (
    <MemberProfileForm
      title={MemberProfileTitle.SignupStep}
      secques={props.secques}
      nationalitys={props.nationalitys}
      occupations={props.occupations}
      postcodes={props.postcodes}
      emailDomains={props.emailDomains}
      memberProfile={props.memberProfile}
      UICode={props.UICode}
      onGoBack={props.onGoBack}
      onFormSubmit={props.onFormSubmit}
      applicationId={props.applicationId}
    />
  );
};

export default MemberProfile;
